import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { StatusChip } from '@cbridge-tools/chip';

export const BooleanCellTrueChip: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <StatusChip
      label={t('text:common.status.enabled')}
      color={'success'}
    />
  );
};
